import React from 'react';
import type { PageFC } from '@salesforce/pwa-kit-react-sdk';
import type { Request, Response } from 'express';
import { Layout } from '../../components/layout/Layout';
import { Redirect } from '../../components/redirect/Redirect';
import { escapeForRegexp } from '../../utils/rio-utils';
import { isServer } from '../../utils/utils';
import { configHtmlCache } from '../utils/config-html-cache';
import { PageUrl } from '../utils/page-url';
import { ShowCategoryPage } from './ShowCategoryPage';
import { getContentData, isCategoryInfo } from './api/getContentData';
import type { ContentInfo } from './api/getContentData';

interface ShowProps {
    contentInfo?: ContentInfo;
}

const Show: PageFC<ShowProps> = ({ contentInfo }: ShowProps) => {
    if (
        contentInfo?.response?.type === 'REDIRECT' &&
        contentInfo?.response?.urlMapping?.destinationUrl
    ) {
        return <Redirect to={contentInfo?.response?.urlMapping?.destinationUrl} type="sg" />;
    }

    if (isCategoryInfo(contentInfo)) {
        if (
            contentInfo?.response?.category?.c_template !==
                'rendering/category/categoryproducthits' &&
            contentInfo?.response?.urlMapping?.destinationUrl &&
            (contentInfo?.response?.urlMapping?.statusCode === 301 ||
                contentInfo?.response?.urlMapping?.statusCode === 302)
        ) {
            return <Redirect to={contentInfo?.response?.urlMapping?.destinationUrl} type="sg" />;
        }

        return <ShowCategoryPage categoryInfo={contentInfo} />;
    }
    return (
        <Layout>
            <h1>Not implemented path</h1>
        </Layout>
    );
};

Show.defaultProps = {
    contentInfo: undefined,
};

Show.shouldGetProps = (): Promise<boolean> => Promise.resolve(isServer);

const SHOW_PAGE_PATTERN = new RegExp(`^${escapeForRegexp(PageUrl.SHOW)}(.*)`);

Show.getProps = async ({
    res,
    req,
    location,
}: {
    location: Location;
    res: Partial<Response>;
    req: Partial<Request>;
}): Promise<ShowProps> => {
    const path = location?.pathname ?? '';
    try {
        configHtmlCache(res);
        const contentInfo = await getContentData(
            path.replace(SHOW_PAGE_PATTERN, '$1'),
            location.search ?? '',
            req,
        );
        return { contentInfo };
    } catch (e) {
        console.error(e);
        return {};
    }
};

export default Show;
